/**
 * Events sent from the Sanity Studio plugin to the Air app
 */
const _SANITY_TO_AIR_EVENT = {
  /** Initialize the Air app with Sanity context */
  Init: 'sanity-to-air:init',
  /** Sync theme with Sanity Studio */
  SyncTheme: 'sanity-to-air:sync-theme',
} as const;

/** @public */
export const SanityToAirEvent = _SANITY_TO_AIR_EVENT;

/** @public */
export type SanityToAirEvent = (typeof SanityToAirEvent)[keyof typeof SanityToAirEvent];

/**
 * Theme options for Sanity Studio
 * @public
 */
export type SanityTheme = 'light' | 'dark';

/**
 * Message: Initialize the Air app
 * @public
 */
export type SanityToAirInit = {
  data: Record<string, unknown>;
  type: typeof SanityToAirEvent.Init;
};

/**
 * Message: Sync theme with Sanity Studio
 * @public
 */
export type SanityToAirSyncTheme = {
  data?: { theme: SanityTheme };
  type: typeof SanityToAirEvent.SyncTheme;
};

/**
 * Union type of all messages from Sanity to Air app
 * @public
 */
export type SanityToAirMessage = SanityToAirInit | SanityToAirSyncTheme;
